import { render, staticRenderFns } from "./minimap.vue?vue&type=template&id=374dfcd6&scoped=true&"
import script from "./minimap.vue?vue&type=script&lang=js&"
export * from "./minimap.vue?vue&type=script&lang=js&"
import style0 from "./minimap.vue?vue&type=style&index=0&id=374dfcd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374dfcd6",
  null
  
)

export default component.exports